
import auth_ee from "./manager"
import Notifier from "app/notifier/index"


import I18n from "plugins/i18n-js"


auth_ee.on("sign_up:success:action", () => {
  Notifier.showSuccess(I18n.t("flashes.users.registrations.signed_up"))
})


auth_ee.on("sign_in:success:action", () => {
  Notifier.showSuccess(I18n.t("flashes.users.sessions.signed_in"))
})
type sign_in_error = "password" | "username"
auth_ee.on("sign_in:error:action", (msg?: sign_in_error) => {
  switch (msg) {
    case "password":
      Notifier.showWarning(I18n.t("js.app.authentication.sign_in.password.invalid"))
      break
    case "username":
      Notifier.showWarning(I18n.t("js.app.authentication.sign_in.email.invalid"))
      break
    default:
      Notifier.showWarning(I18n.t("js.app.authentication.sign_in.invalid"))
      break
  }
})

auth_ee.on("forgot_password:success:action", () => {
  Notifier.showSuccess(I18n.t("flashes.users.passwords.instruction_sent"))
})
auth_ee.on("forgot_password:error:action", () => {
  Notifier.showWarning(I18n.t("flashes.users.passwords.not_found"))
})
